import { render, staticRenderFns } from "./ManualContact.vue?vue&type=template&id=650deb38"
import script from "./ManualContact.vue?vue&type=script&lang=js"
export * from "./ManualContact.vue?vue&type=script&lang=js"
import style0 from "./ManualContact.vue?vue&type=style&index=0&id=650deb38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports